// AAR (Association of American Railroads) Standard Radio Channels
// Complete list for North American railroad communications

export const AAR_CHANNELS = [
  // Road Channels (Main line operations)
  { channel: 1, frequency: "160.215", use: "Road", notes: "UP, BNSF" },
  { channel: 2, frequency: "160.230", use: "Road", notes: "CSX" },
  { channel: 3, frequency: "160.245", use: "Road", notes: "NS" },
  { channel: 4, frequency: "160.260", use: "Road", notes: "CN" },
  { channel: 5, frequency: "160.275", use: "Road", notes: "CP" },
  { channel: 6, frequency: "160.290", use: "Road", notes: "" },
  { channel: 7, frequency: "160.305", use: "Road", notes: "" },
  { channel: 8, frequency: "160.320", use: "Road", notes: "" },
  { channel: 9, frequency: "160.335", use: "Road", notes: "" },
  { channel: 10, frequency: "160.350", use: "Road", notes: "" },
  { channel: 11, frequency: "160.365", use: "Road", notes: "" },
  { channel: 12, frequency: "160.380", use: "Road", notes: "" },
  { channel: 13, frequency: "160.395", use: "Road", notes: "" },
  { channel: 14, frequency: "160.410", use: "Road", notes: "" },
  { channel: 15, frequency: "160.425", use: "Road", notes: "" },
  { channel: 16, frequency: "160.440", use: "Road", notes: "NS Primary" },
  { channel: 17, frequency: "160.455", use: "Road", notes: "" },
  { channel: 18, frequency: "160.470", use: "Road", notes: "" },
  { channel: 19, frequency: "160.485", use: "Road", notes: "" },
  { channel: 20, frequency: "160.500", use: "Road", notes: "" },
  
  // Yard Channels
  { channel: 21, frequency: "160.515", use: "Yard", notes: "" },
  { channel: 22, frequency: "160.530", use: "Yard", notes: "" },
  { channel: 23, frequency: "160.545", use: "Yard", notes: "" },
  { channel: 24, frequency: "160.560", use: "Yard", notes: "" },
  { channel: 25, frequency: "160.575", use: "Yard", notes: "" },
  { channel: 26, frequency: "160.590", use: "Yard", notes: "" },
  { channel: 27, frequency: "160.605", use: "Yard", notes: "" },
  { channel: 28, frequency: "160.620", use: "Yard", notes: "" },
  { channel: 29, frequency: "160.635", use: "Yard", notes: "" },
  { channel: 30, frequency: "160.650", use: "Yard", notes: "" },
  { channel: 31, frequency: "160.665", use: "Yard", notes: "" },
  { channel: 32, frequency: "160.680", use: "Yard", notes: "" },
  { channel: 33, frequency: "160.695", use: "Yard", notes: "" },
  { channel: 34, frequency: "160.710", use: "Yard", notes: "" },
  { channel: 35, frequency: "160.725", use: "Yard", notes: "" },
  { channel: 36, frequency: "160.740", use: "Yard", notes: "" },
  { channel: 37, frequency: "160.755", use: "Yard", notes: "" },
  { channel: 38, frequency: "160.770", use: "Yard", notes: "" },
  { channel: 39, frequency: "160.785", use: "Yard", notes: "" },
  { channel: 40, frequency: "160.800", use: "Yard", notes: "" },
  
  // Dispatcher/MoW Channels
  { channel: 41, frequency: "160.815", use: "Dispatcher", notes: "" },
  { channel: 42, frequency: "160.830", use: "Dispatcher", notes: "" },
  { channel: 43, frequency: "160.845", use: "Dispatcher", notes: "" },
  { channel: 44, frequency: "160.860", use: "Dispatcher", notes: "" },
  { channel: 45, frequency: "160.875", use: "Dispatcher", notes: "" },
  { channel: 46, frequency: "160.890", use: "Dispatcher", notes: "" },
  { channel: 47, frequency: "160.905", use: "MoW", notes: "Maintenance of Way" },
  { channel: 48, frequency: "160.920", use: "MoW", notes: "" },
  { channel: 49, frequency: "160.935", use: "MoW", notes: "" },
  { channel: 50, frequency: "160.950", use: "MoW", notes: "" },
  { channel: 51, frequency: "160.965", use: "MoW", notes: "" },
  { channel: 52, frequency: "160.980", use: "MoW", notes: "" },
  { channel: 53, frequency: "160.995", use: "MoW", notes: "" },
  { channel: 54, frequency: "161.010", use: "MoW", notes: "" },
  { channel: 55, frequency: "161.025", use: "MoW", notes: "" },
  { channel: 56, frequency: "161.040", use: "MoW", notes: "" },
  { channel: 57, frequency: "161.055", use: "MoW", notes: "" },
  { channel: 58, frequency: "161.070", use: "MoW", notes: "" },
  { channel: 59, frequency: "161.085", use: "MoW", notes: "" },
  { channel: 60, frequency: "161.100", use: "Police/Emergency", notes: "Railroad Police" },
  
  // Additional Road Channels
  { channel: 61, frequency: "161.115", use: "Road", notes: "" },
  { channel: 62, frequency: "161.130", use: "Road", notes: "" },
  { channel: 63, frequency: "161.145", use: "Road", notes: "" },
  { channel: 64, frequency: "161.160", use: "Road", notes: "" },
  { channel: 65, frequency: "161.175", use: "Road", notes: "" },
  { channel: 66, frequency: "161.190", use: "Road", notes: "" },
  { channel: 67, frequency: "161.205", use: "Road", notes: "" },
  { channel: 68, frequency: "161.220", use: "Road", notes: "" },
  { channel: 69, frequency: "161.235", use: "Road", notes: "" },
  { channel: 70, frequency: "161.250", use: "Road", notes: "" },
  { channel: 71, frequency: "161.265", use: "Road", notes: "" },
  { channel: 72, frequency: "161.280", use: "Road", notes: "" },
  { channel: 73, frequency: "161.295", use: "Road", notes: "" },
  { channel: 74, frequency: "161.310", use: "Road", notes: "" },
  { channel: 75, frequency: "161.325", use: "Road", notes: "" },
  { channel: 76, frequency: "161.340", use: "Road", notes: "" },
  { channel: 77, frequency: "161.355", use: "Road", notes: "CSX Primary" },
  { channel: 78, frequency: "161.370", use: "Road", notes: "" },
  { channel: 79, frequency: "161.385", use: "Road", notes: "" },
  { channel: 80, frequency: "161.400", use: "Road", notes: "" },
  
  // Intermodal/Special
  { channel: 81, frequency: "161.415", use: "Intermodal", notes: "" },
  { channel: 82, frequency: "161.430", use: "Intermodal", notes: "" },
  { channel: 83, frequency: "161.445", use: "Intermodal", notes: "" },
  { channel: 84, frequency: "161.460", use: "Intermodal", notes: "" },
  { channel: 85, frequency: "161.475", use: "Intermodal", notes: "" },
  { channel: 86, frequency: "161.490", use: "PBX", notes: "Private Branch Exchange" },
  { channel: 87, frequency: "161.505", use: "PBX", notes: "" },
  { channel: 88, frequency: "161.520", use: "EOT", notes: "End of Train" },
  { channel: 89, frequency: "161.535", use: "EOT", notes: "" },
  { channel: 90, frequency: "161.550", use: "EOT", notes: "" },
  { channel: 91, frequency: "161.565", use: "Passenger", notes: "Amtrak" },
  { channel: 92, frequency: "161.580", use: "Passenger", notes: "" },
  { channel: 93, frequency: "161.595", use: "Passenger", notes: "" },
  { channel: 94, frequency: "160.200", use: "Switching", notes: "" },
  { channel: 95, frequency: "452.900", use: "Defect Detector", notes: "DED" },
  { channel: 96, frequency: "452.9375", use: "Defect Detector", notes: "DED" },
  { channel: 97, frequency: "457.9375", use: "Defect Detector", notes: "DED" },
];

// Common railroad-specific channels
export const RAILROAD_CHANNELS = {
  "BNSF": [1, 2, 3, 61, 62, 63],
  "UP": [1, 4, 5, 64, 65, 66],
  "NS": [3, 16, 17, 70, 71, 72],
  "CSX": [2, 77, 78, 79, 80],
  "CN": [4, 5, 6, 67, 68],
  "CP": [5, 6, 7, 69, 70],
  "KCS": [8, 9, 10, 73, 74],
  "Amtrak": [91, 92, 93],
};

// Channel use types for filtering
export const CHANNEL_USES = [
  "Road",
  "Yard", 
  "Dispatcher",
  "MoW",
  "Police/Emergency",
  "Intermodal",
  "PBX",
  "EOT",
  "Passenger",
  "Switching",
  "Defect Detector"
];

// Helper function to get channel display string
export const formatChannel = (channel) => {
  const ch = AAR_CHANNELS.find(c => c.channel === channel);
  if (!ch) return `Ch ${channel}`;
  return `Ch ${ch.channel} (${ch.frequency} MHz) - ${ch.use}`;
};

// Helper to get channel by number
export const getChannel = (channelNum) => {
  return AAR_CHANNELS.find(c => c.channel === channelNum);
};

export default AAR_CHANNELS;
